/**
 * Created by Amit Panghal
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {PPGameMode} from "../../gamemode/PPGameMode";
import {PixiesVsPiratesSoundConfig} from "../../PixiesVsPiratesSoundConfig";
import {PixiesVsPiratesReelAttentionView} from "./PixiesVsPiratesReelAttentionView";

export class PixiesVsPiratesReelAttentionController extends ReelStopPresentationController {
    private _anticipationSoundPlaying:boolean;
    private _view:PixiesVsPiratesReelAttentionView;
    private _nearWinStates:boolean[];

    constructor(index:number) {
        super(index, "reelAttention");
        this._view = new PixiesVsPiratesReelAttentionView();
        this._anticipationSoundPlaying = false;
        this._nearWinStates = ArrayHelper.initArrayWithValues(5, (index:number) => false);
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinReelEvent.REEL_ON_NEAR_WIN, (event:GameEvent) => this.onReelNearWin(event.params[0]));
    }

    private onReelNearWin(reelId:number):void {
        if(!this._anticipationSoundPlaying) {
            SlotGame.sound.playEffect(PixiesVsPiratesSoundConfig.ANTICIPATION);
            this._anticipationSoundPlaying = true;
        }
        this._nearWinStates[reelId] = true;
        this._view.playNearWin(reelId);
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._nearWinStates[data.reelId]) {
            this._nearWinStates[data.reelId] = false;
            this._view.stopNearWin(data.reelId);
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(this._gameData!.nextMode !== PPGameMode.FREESPIN_PICK && data.reelId === 5 && this._anticipationSoundPlaying) {
            SlotGame.sound.playEffect(PixiesVsPiratesSoundConfig.ANTICIPATION_FAIL);
        }
        if(data.quickStop || data.reelId === 5) {
            SlotGame.sound.stopEffect(PixiesVsPiratesSoundConfig.ANTICIPATION);
            this._anticipationSoundPlaying = false;
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    protected resetFeature():void {
        this._view.reset();
    }
}